import { useTranslation } from "react-i18next"
import style from "../../../assets/scss/components/global/articleCard.module.scss"
import noImage from "../../../assets/img/image_not_supported.png"
import Check from "../../form/Check"
import Text from "../../content/Text"
import Accordion, { AccordionItem } from "@ingka/accordion"
import Table from "../../content/Table"

// Customised cell component to avoid duplication
const CustomCell = ({ cell }) => (
  <span>
    <b>{cell.getValue()}</b>
  </span>
);

const columns =  [
  { enableSorting:false,accessorKey: "stockOnHand",header:"Stock on hand", size: 40, Cell: CustomCell },
  { enableSorting:false,accessorKey: "rts", header: "RTS", size: 40, Cell: CustomCell },
  { enableSorting:false,accessorKey: "vms", header: "VMS", size: 40, Cell: CustomCell },
  { enableSorting:false,accessorKey: "salesWeekGoal", header: "Sales week Goal", size: 40, Cell: CustomCell }
]

const EDS_CLASS_COLORS = {
  C: 'red',
  Z: 'red',
  B: 'gold',
  A: 'green',
  E: 'black'
}

export default function ArticleCard({ props, handleChange }) {
  const [t] = useTranslation("global");
  const { articleNumber, itemInfoDTO, idTask, price, localPrice,  rts,
    vms, salesWeekGoal, stockOnHand, edsClass } = props;

  return (
    <div className={style.article}>
      <ArticleHeader item={articleNumber} edsClass={edsClass}  handleChange={handleChange} />
      
      <div className={style.body}>
        <ArticleContent name={itemInfoDTO.name} description={itemInfoDTO.description} />
        <div className={style.image}>
          <img src={itemInfoDTO.image || noImage} alt="Product" />
        </div>
      </div>
      
      <div className={style.data}>
        <PriceInfo price={price} localPrice={localPrice}/>
      </div>
      
      <Accordion>
        <AccordionItem className={style.accordion} caption={t("new-action.moreData")} id={idTask}>
          <Table columns={columns} data={[{
            stockOnHand,
      rts,
      vms,
      salesWeekGoal
  }]} />
        </AccordionItem>
      </Accordion>
    </div>
  )
}

// Component for the article header
function ArticleHeader({ item, edsClass, handleChange }) {
  return (
    <div className={style.header}>
      <div style={{ display: 'flex', gap: '0.5rem'}}>
      <div className={style.ref}>{item}</div>
      <div className={style.ref} style={{ backgroundColor: `${EDS_CLASS_COLORS[edsClass]}`, color: 'white'}}>{edsClass}</div>
      </div>
      {handleChange && <Check
        formField={{
          style: { margin: 0 },
          fieldHelper: {
            id: "helper-msg-id",
            type: "",
          },
        }}
        check={{
          onChange: handleChange,
          value: item,
          id: item,
          name: item,
        }}
      />}
    </div>
  )
}

// Component for article content
function ArticleContent({ name, description }) {
  return (
    <div className={style.content}>
      <Text tagName="h3" headingSize="m">{name}</Text>
      <Text tagName="p" bodySize="m">{description}</Text>
    </div>
  )
}

// Component for price information
function PriceInfo({price, localPrice}) {
  return (
    <div>
      <Text tagName="p" bodySize="s">Price: <b>{price} €</b></Text>
      <Text tagName="p" bodySize="s">Local Price: <b>{localPrice} €</b></Text>
    </div>
  );
}
